/**
 * Get meta description from product description AND/OR title and brand.
 * @param desription
 * @param title
 * @param brand
 * @returns string
 */
export const getMetaDescription = (description?: string | null, title?: string | null, brand?: string | null) => {
  const metaDescription =
    description
      ?.trim()
      ?.match(/[^.!?]+[.!?]+/g)
      ?.slice(0, 2)
      .join(' ') || description?.trim();
  return `Shop ${title} from ${brand}. ${metaDescription}`;
};
